<template>
    <CardPage :section="8" :page="4" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! You are Jeopar-T all star! You’ve earned another sticker for your trophy case.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
        <div v-if="score === maxScore">
            <p>And you got the max score! Way to go!!</p>
            <ResponsiveImage :src="bonusSticker.image" :alt="bonusSticker.text"></ResponsiveImage>
        </div>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section8/sticker'),
        bonusSticker: get('section8/bonusSticker'),
        score: get('section8/score'),
        maxScore: get('section8/maxScore')
    },
    methods: {
        finish() {
            this.$store.set('section8/complete', true);
            this.$store.set('section8/sticker@earned', true);
            if (this.score === this.maxScore) {
                this.$store.set('section8/bonusSticker@earned', true);
            }
        }
    }
};
</script>
